import { push } from './utils';

export const goToDashboard = () => {
  return push('/');
};
